/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcSweepsV1SweepPlanQueryServiceSweepPlanGetResponse, IxcSweepsV1SweepPlanQueryServiceSweepPlanGetSweepPlanGetRequest } from '@interxfi/types';

export const IXC_SWEEPS_V1_SWEEP_PLAN_QUERY_SERVICE_SWEEP_PLAN_GET_AUDIENCE = ['clearing', 'program'];

export async function ixcSweepsV1SweepPlanQueryServiceSweepPlanGet(baseUrl: string | undefined, request?: IxcSweepsV1SweepPlanQueryServiceSweepPlanGetSweepPlanGetRequest, requestInit?: RequestInit): Promise<IxcSweepsV1SweepPlanQueryServiceSweepPlanGetResponse | undefined> { return makeRequest<IxcSweepsV1SweepPlanQueryServiceSweepPlanGetResponse, IxcSweepsV1SweepPlanQueryServiceSweepPlanGetSweepPlanGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/sweeps/v1/sweep_plan/q/:sweepPlanId', request, requestInit)); }

